/** sonner の Toaster を仕様書のスタイルでラップ。 */
import { Toaster as SonnerToaster } from 'sonner';

import { useTheme } from '@/hooks/useTheme';

export function Toaster() {
  const { theme } = useTheme();
  return (
    <SonnerToaster
      position="bottom-right"
      theme={theme}
      duration={3000}
      closeButton
      toastOptions={{
        style: {
          background: 'var(--bg-elevated)',
          border: '1px solid var(--border)',
          color: 'var(--text-primary)',
          borderRadius: 'var(--radius-sm)',
          fontSize: '13px',
        },
        className: 'sonner-toast',
      }}
    />
  );
}

export { toast } from 'sonner';
